import $ from 'jquery';
import EventBus from './EventBus';

const OPTIONAL_CONSENT_CATEGORIES = ['preferences', 'statistics', 'marketing'];

function notifyCmConsentListeners(signals) {
  if (!signals) {
    return;
  }
  (window.__cmConsentListeners || []).forEach((callback) => {
    callback(signals);
  });
}

function notifyFromConsentResponse(data) {
  if (data && data.google_consent) {
    notifyCmConsentListeners(data.google_consent);
  }
}

function grantedCategoriesFromConsentData(data) {
  if (!data) {
    return [];
  }

  return OPTIONAL_CONSENT_CATEGORIES.filter((category) => data[category]);
}

function shouldActivateScript(script, grantedCategories) {
  const category = script.getAttribute('data-consent-category');

  if (category) {
    return grantedCategories.includes(category);
  }

  // Untagged legacy scripts (GTM/gtag): activate after Accept / any optional grant.
  return grantedCategories.length > 0;
}

function activateScript(inertScript) {
  const liveScript = document.createElement('script');
  liveScript.type = 'text/javascript';

  Array.from(inertScript.attributes).forEach((attribute) => {
    if (attribute.name === 'type' || attribute.name === 'data-consent-category') {
      return;
    }

    if (attribute.name === 'async') {
      liveScript.async = true;
      return;
    }

    liveScript.setAttribute(attribute.name, attribute.value);
  });

  if (inertScript.async) {
    liveScript.async = true;
  }

  if (inertScript.textContent) {
    liveScript.text = inertScript.textContent;
  }

  inertScript.after(liveScript);
  inertScript.remove();
}

function recreateScripts(grantedCategories = []) {
  document.querySelectorAll("script[type='text/plain']").forEach((script) => {
    if (shouldActivateScript(script, grantedCategories)) {
      activateScript(script);
    }
  });
}

function isConsentCookiesUrl(url) {
  return Boolean(url && /\/cookies\/(accept|adjust|revoke)/.test(url));
}

function shouldActivateScriptsForUrl(url) {
  return /\/cookies\/(accept|adjust)/.test(url);
}

function handleCookiesAjaxSuccess(xhr, settings) {
  if (!settings || !isConsentCookiesUrl(settings.url)) {
    return;
  }

  let data;
  try {
    data = JSON.parse(xhr.responseText);
  } catch (_error) {
    return;
  }

  notifyFromConsentResponse(data);

  if (shouldActivateScriptsForUrl(settings.url)) {
    recreateScripts(grantedCategoriesFromConsentData(data));
  }
}

$(function () {
  let resizeListeners = [];
  const noticeContainer = $('.cookie-consent-notice-container');
  const bookingFloatingFooter = $('.v2-booking-floating-footer');

  noticeContainer.on('click', '.accept-btn', function (e) {
    recreateScripts(OPTIONAL_CONSENT_CATEGORIES);
    $(e.delegateTarget).hide();
    resizeListeners.forEach((fn) => fn());
  });

  $(document).ajaxSuccess(function (_event, xhr, settings) {
    handleCookiesAjaxSuccess(xhr, settings);
  });

  $(window).on('resize', function () {
    resizeListeners.forEach((fn) => fn());
  });

  function noticeHeight() {
    return noticeContainer.is(':visible') ? noticeContainer.outerHeight() : 0;
  }

  function noticeWithBookingFloatingFooterHeight() {
    return bookingFloatingFooter.is(':visible') ? noticeHeight() + bookingFloatingFooter.height() : noticeHeight();
  }

  if (typeof zE !== 'undefined') {
    var adjustZendeskLauncher = () => {
      const height = noticeWithBookingFloatingFooterHeight();
      $('#zendesk-launcher').css('bottom', height + 20 + 'px');
    };

    const adjustZendeskWhenExists = () => {
      if (noticeContainer.is(':visible') || bookingFloatingFooter.is(':visible')) {
        const checkExist = setInterval(() => {
          if ($('#zendesk-launcher').is(':visible')) {
            adjustZendeskLauncher();
            clearInterval(checkExist);
          }
        }, 100);
      }
    };

    resizeListeners.push(adjustZendeskLauncher);
    adjustZendeskWhenExists();
  }

  const workPage = $('.work-page');
  if (workPage.length) {
    function adjustBookingFloatingFooter() {
      bookingFloatingFooter.attr('style', 'bottom: ' + noticeHeight() + 'px !important;');
      workPage.attr('style', 'margin-bottom: ' + noticeHeight() + 'px !important;');
    }

    resizeListeners.push(adjustBookingFloatingFooter);

    if (typeof zE !== 'undefined') {
      EventBus.on('basket:end-fetching-quote', adjustZendeskLauncher);
    }

    adjustBookingFloatingFooter();
  }
});

export {
  OPTIONAL_CONSENT_CATEGORIES,
  grantedCategoriesFromConsentData,
  handleCookiesAjaxSuccess,
  notifyCmConsentListeners,
  notifyFromConsentResponse,
  recreateScripts,
};
